import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';


import { QUERY_KEY_SESSION } from '../constants.js';

import { exchangeGithubCode, fetchSession, logoutSession } from './session.js';

import { apiClient } from '@/lib/api.js';

export function useSession() {
  return useQuery({
    queryKey: QUERY_KEY_SESSION,
    queryFn: () => fetchSession(apiClient),
    retry: false,
  });
}

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code) => exchangeGithubCode(code, apiClient),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_SESSION }),
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => logoutSession(apiClient),
    onSuccess: () => {
      queryClient.setQueryData(QUERY_KEY_SESSION, null);
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_SESSION });
    },
  });
}
